export class PageStyle {
  PageStyleId: number;
  CompanyId: number;
  Html: string;
  Css: string;
  AIHubPaymentRequestHtml: string;
  AIHubPaymentRequestCss: string;
  WelcomeText: string;
  HeaderColor: string
  HeadingTextColor: string;
  BodyTextColor: string;
  ButtonColor: string;
  LogoImageFileName: string;
  BackgroundImageFileName: string;
  PaymentActionPageCss: string;

  constructor(companyId?: number) {
    this.PageStyleId = null;
    this.CompanyId = null;
    this.Html = null;
    this.Css = null;
    this.AIHubPaymentRequestHtml = null;
    this.AIHubPaymentRequestCss = null;
    this.WelcomeText = null;
    this.HeaderColor = null;
    this.HeadingTextColor = null;
    this.BodyTextColor = null;
    this.ButtonColor = null;
    this.LogoImageFileName = null;
    this.BackgroundImageFileName = null;
    this.PaymentActionPageCss = null;

    if (companyId) {
      this.CompanyId = companyId;
    }
  }
}
